import { render } from "./AccountTypeGrid.vue?vue&type=template&id=24dd0553&scoped=true"
import script from "./AccountTypeGrid.vue?vue&type=script&lang=js"
export * from "./AccountTypeGrid.vue?vue&type=script&lang=js"

import "./AccountTypeGrid.vue?vue&type=style&index=0&id=24dd0553&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dd0553"]])

export default __exports__